import getRadiologistDash from "@custom/rtk-apis/analytics/getRadiologistDash";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const getRadiologistDashboard = createSlice({
  name: "getRadiologistDashboard",
  initialState,
  reducers: {
    clearRadiologistDashboard: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRadiologistDash.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getRadiologistDash.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = "SUCCESS";
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(getRadiologistDash.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default getRadiologistDashboard.reducer;
export const { clearRadiologistDashboard } = getRadiologistDashboard.actions;
